const dateFormat = require('dateformat');
const { getProperty } = require('../PropertyGetter');

// Parsing through the CCFP Data from xAPI
const getCCFPData = (product, actualPrice, additionalData) => {
  if (!getProperty(additionalData, 'featureEligible.ccfp', false)) return {};

  const ccfpObject = getProperty(product, 'ccfp', {});
  const FORMAT = 'mm/dd/yyyy';
  const todaysDate = dateFormat(new Date(), FORMAT);
  const messageAPR = ccfpObject.messageAPR.replace(/__DATE__/g, todaysDate);

  const departmentId = getProperty(product, 'department.departmentId', 0);
  const {
    value: price, formattedPrice,
  } = actualPrice;
  const chargePlanPDPDeptDetails = ccfpObject.chargePlanPDPDeptDetails[departmentId]
    .map(planDetail => ({
      ...planDetail,
      pricePerMonth: Math.ceil(price / planDetail.ticketTermCode),
    }));
  const qualifiedPlanDetails = chargePlanPDPDeptDetails.filter(planDetail => planDetail.minimumPurchase <= price);
  const minimumPurchase = chargePlanPDPDeptDetails
    .reduce((min, planDetail) => Math.min(min, planDetail.minimumPurchase), Number.MAX_VALUE);
  const seatEligible = !!qualifiedPlanDetails.length;
  return {
    addOn: Math.ceil(minimumPurchase - price),
    chargePlanPDPDeptDetails,
    qualifiedPlanDetails,
    seatEligible,
    isSingleSeat: qualifiedPlanDetails.length === 1,
    targetPlan: seatEligible ? qualifiedPlanDetails[qualifiedPlanDetails.length - 1] : chargePlanPDPDeptDetails[0],
    formattedPrice,
    messageAPR,
    minimumPurchase,
  };
};

module.exports = {
  getCCFPData,
};



// WEBPACK FOOTER //
// /Users/m802941/WebstormProjects/2020/campaigns/shop-the-look-pdp/node_modules/@page/digital-product-ui-mcom/src/js/util/viewState/Ccfp.js